export const HANSE_MERKUR = '649d4cce625a11eea2008b0b'
